// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Box, CloseButton, List, Stack, Text } from "@mantine/core";
import { FC, useState } from "react";
import ListItem from "./ListItem";
import PractitionersList from 'Modules/PractitionersList';
import { store } from 'stores/Store';

interface Props {
  practitioners: any[];
  onPractitionerSelected: (p: any) => void;
}

const ListView: FC<Props> = ({ practitioners, onPractitionerSelected }) => {
  const [hideOnViewList, setHideOnViewList] = useState(false);
  // used to control weather we should display onViewList or searchResults
  const [ searchTerm, setSearchTerm ] = useState("");

  return (
    <Box pos="relative">
      <Box
        style={{
          zIndex: 6000,
          position: "absolute",
          background: "rgba(255, 255, 255, 0.9)",
          top: 0,
          width: "100%",
          height: !hideOnViewList ? 50 : "auto",
          padding: 0,
          margin: 0,
          overflow: "hidden",
          boxSizing: "border-box",
        }}>
        <PractitionersList
          isDropdown={true}
          hideList={!hideOnViewList}
          onSeachTermChange={(t) => {
            if (searchTerm === "") {
              setSearchTerm(t);
            } else {
              if (searchTerm !== t) {
                setHideOnViewList(true);
              }
            }
          }}
          onPractitionerSelect={() => {
            const currentPractitioner = store?.currentPractitioner;
            onPractitionerSelected(currentPractitioner);
          }}
          onOpenLeadCreate={() => {
          }}
          CustomPractitionerRenderer={(({ practitioner, index }) => (
            <Box px={15}>
              <ListItem
                onClick={() => onPractitionerSelected(practitioner)}
                key={index}
                practitioner={practitioner}
                index={index + 1} />
            </Box>
          ))}
        />
      </Box>
      {!hideOnViewList && (
        <Box pt="60px" px={15}>
          <Text fz={10} c="#8B8B8B" ta="right">
            Displaying accounts visible on map, sorted by distance to you
          </Text>
          {practitioners.length <= 40 ? (
            <>
              {practitioners.map((p, index) => (
                <ListItem
                  onClick={() => onPractitionerSelected(p)}
                  key={index}
                  practitioner={p}
                  index={index + 1} />
              ))}
            </>
          ) : (
            <Stack align="center" mt={120} gap={30} px={20}>
              <CloseButton bg="#E64B37" c="white" bdrs="50%" w={40} h={40} />
              <Text c="#E64B37" fz={20} ta="center">
                There are too many accounts on your map!
              </Text>
              <Text c="#E64B37" fz={20} ta="center">
                Please zoom in and we'll make this happen.
              </Text>
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ListView;